import { motion } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

const IMAGES = [
  {
    url: "https://images.unsplash.com/photo-1492175742197-ed20dc5a6bed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwYnJpZGUlMjBwb3J0cmFpdCUyMGx1eHVyeSUyMHdlZGRpbmd8ZW58MHx8fHwxNzgwNzY4ODY3fDA&ixlib=rb-4.1.0&q=85",
    caption: "Mira & James, The Ned, London",
    span: "row-span-2",
  },
  {
    url: "https://images.unsplash.com/photo-1460978812857-470ed1c77af0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwyfHxjYW5kaWQlMjB3ZWRkaW5nJTIwY291cGxlJTIwYmxhY2slMjBhbmQlMjB3aGl0ZXxlbnwwfHx8fDE3ODA3Njg4Njd8MA&ixlib=rb-4.1.0&q=85",
    caption: "Hattie & Sam, Hedsor House",
    span: "",
  },
  {
    url: "https://images.unsplash.com/photo-1532454781337-fc3edff34f91?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwzfHxlbGVnYW50JTIwYnJpZGUlMjBwb3J0cmFpdCUyMGx1eHVyeSUyMHdlZGRpbmd8ZW58MHx8fHwxNzgwNzY4ODY3fDA&ixlib=rb-4.1.0&q=85",
    caption: "Studio Session, Essex",
    span: "",
  },
  {
    url: "https://images.unsplash.com/photo-1737682599438-319b61711b5f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjB3ZWRkaW5nJTIwdGFibGUlMjBzZXR0aW5nJTIwZGVjb3J8ZW58MHx8fHwxNzgwNzY4ODY3fDA&ixlib=rb-4.1.0&q=85",
    caption: "The Reception, Cliveden",
    span: "row-span-2",
  },
  {
    url: "https://images.pexels.com/photos/32920517/pexels-photo-32920517.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    caption: "Eleanor & Theo, Country Estate",
    span: "",
  },
  {
    url: "https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=1200&q=80",
    caption: "First Look, Mayfair",
    span: "",
  },
];

export default function Portfolio() {
  return (
    <section
      id="portfolio"
      data-testid="portfolio-section"
      className="px-6 md:px-12 lg:px-24 py-20 md:py-28"
    >
      <div className="grid grid-cols-1 gap-6 md:grid-cols-12 mb-12 md:mb-16 items-end">
        <div className="md:col-span-7">
          <h2 className="font-serif-display tracking-tight leading-[0.95] text-3xl sm:text-4xl md:text-6xl">
            Selected <span className="italic">work.</span>
          </h2>
        </div>
        <div className="md:col-span-5 md:text-right">
          <p className="text-foreground/70 max-w-md md:ml-auto leading-relaxed">
            A small private archive. Each story photographed with the same care.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-5 auto-rows-[280px] md:auto-rows-[360px]">
        {IMAGES.map((img, i) => (
          <motion.figure
            key={i}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, ease, delay: (i % 3) * 0.08 }}
            data-testid={`portfolio-item-${i}`}
            className={`group relative overflow-hidden bg-secondary ${img.span}`}
          >
            <img
              src={img.url}
              alt={img.caption}
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/0 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
            <figcaption className="absolute bottom-4 left-5 right-5 text-[#F6F1E8] eyebrow opacity-0 group-hover:opacity-100 transition-opacity duration-700">
              {img.caption}
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </section>
  );
}
